import React, { useContext, useEffect, useState } from "react";
import "./Blog_details.css";
import Blog_card from "../blog_card/Blog_card";
import Common_breadcrumb from "../../common_components/common_breadcrumb/Common_breadcrumb";
import Common_Heading from "../../common_components/common_Heading/Common_Heading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import {
  Insights,
  SingleInsights,
} from "../../../utils/luxuryapis/Event/Event";
import { Context } from "../../../utils/context";

function Blog_details() {
  const breadcrumbItems = [
    { label: "HOME", link: "/luxury/home" },
    { label: "Insight", link: "/luxury/articles" },
    { label: "Insight Details" },
  ];

  const blogs = [
    {
      id: 1,
      date: "FRIDAY, MAY 9, 2025",
      title:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum The Extremes of Good and Evil by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of de Finibus Bonorum et Malorum The Extremes of Good and Evil by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, Lorem ipsum dolor sit amet.., comes from a line in section 1.10.32.",
      image: "/assest/luxury_images/products/new_img3.png",
    },
    {
      id: 2,
      date: "SATURDAY, MAY 10, 2025",
      title:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: "/assest/luxury_images/products/new_img3.png",
    },
    {
      id: 3,
      date: "SUNDAY, MAY 11, 2025",
      title:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: "/assest/luxury_images/products/new_img3.png",
    },
  ];

  // ✅ Default selected blog (first blog)
  const [selectedBlog, setSelectedBlog] = useState();

  const { id } = useParams();

  const { IMG_URL } = useContext(Context);
  const getAllDataSingle = async () => {
    const res = await SingleInsights(id);
    if (res?.success) {
      setSelectedBlog(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getAllDataSingle();
  }, [id]);

  const [data, setData] = useState();

  const getAllData = async () => {
    const res = await Insights();
    if (res?.success) {
      setData(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getAllData();
  }, []);
  return (
    <>
      <section className="Blog_details">
        <div className="custom_container">
          <Common_breadcrumb items={breadcrumbItems} />

          <div className="heading_holder">
            <Common_Heading
              headingText={"LATEST UPDATES"}
              subHeadingText={"You never want to miss"}
            />
          </div>

          <div className="row">
            {/* ✅ LEFT SIDE BLOG DETAILS */}
            <div className="col-md-8">
              <div className="blog_card_details_holder">
                <Link to={"/luxury/articles"}>
                  <div className="icon_holder">
                    <FontAwesomeIcon className="cross_icon" icon={faXmark} />
                  </div>
                </Link>
                <Blog_card blogDetails={selectedBlog} IMG_URL={IMG_URL} />
              </div>
            </div>

            {/* ✅ RIGHT SIDE BLOG LIST */}
            <div className="col-md-4">
              <div className="card_list_holder">
                <div className="blog_card_holder">
                  <div className="row justify-content-center">
                    {data?.data?.map((blog) => (
                      <div
                        className="col-xl-12 col-md-12 col-sm-8 col-12"
                        key={blog.id}
                      >
                        <div
                          onClick={() => setSelectedBlog(blog)}
                          style={{ cursor: "pointer" }}
                        >
                          <Blog_card blog={blog} IMG_URL={IMG_URL} />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Blog_details;
